import { TsDOM as q } from '@/scripts/core/TsDOM';
import { DeferredMedia } from '@/scripts/interactive-defer/deferred-media'
import { DetailsDisclosure } from '@/scripts/interactive-defer/details-disclosure'
import { CartDrawer } from '@/scripts/interactive-defer/cart-drawer'
import { CartNote } from '@/scripts/interactive-defer/cart-note'
import { CartDrawerItems } from '@/scripts/interactive-defer/cart-drawer-items'
import { CartRemoveButton } from '@/scripts/interactive-defer/cart-remove-button'
import { CartItems } from '@/scripts/interactive-defer/cart-items';
import { PredictiveSearch } from '@/scripts/interactive-defer/predictive-search';
import { QuantityInput } from '@/scripts/theme/quantity-input';
import { SearchForm } from '@/scripts/interactive-defer/search-form';
import { HeaderMenu } from '@/scripts/interactive-defer/header-menu';
import { DetailsModal } from '@/scripts/interactive-defer/details-modal';
import { MenuDrawer } from '@/scripts/interactive-defer/menu-drawer';
import { HeaderDrawer } from '@/scripts/interactive-defer/header-drawer';
import { ModalDialog } from '@/scripts/interactive-defer/modal-dialog';
import { ModalOpener } from '@/scripts/interactive-defer/modal-opener';
import { WaitlistForm } from '@/scripts/interactive-defer/waitlist-form'
import { ContactFormModal } from '@/scripts/interactive-defer/contact-form-modal'
import { KlaviyoForm } from '@/scripts/interactive-defer/klaviyo-form'
import { WaitlistPopup, WelcomePopup } from '@/scripts/interactive-defer/welcome-popup'
import { ProductRecommendations } from '@/scripts/interactive-defer/product-recommendations';
import { ExpandableContent } from '@/scripts/interactive-defer/expandable-content'
import { LocalizationForm } from '@/scripts/interactive-defer/localization-form'
import { openCartIfRedirect } from '@/scripts/interactive-defer/cart-functions'
import { RecentlyViewedManager } from '@/scripts/interactive-defer/recently-viewed-manager'
import { deferredGlobalSetup } from '@/scripts/interactive-defer/global-defer'
import { initSwym } from '@/scripts/interactive-defer/swym-init'
import { WishlistButton } from '@/scripts/interactive-defer/wishlist-button'

deferredGlobalSetup()
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(ExpandableContent)
q.safeDefineElement(ProductRecommendations)
q.safeDefineElement(QuantityInput)
q.safeDefineElement(CartDrawer)
q.safeDefineElement(CartNote)
q.safeDefineElement(CartItems)
q.safeDefineElement(CartDrawerItems)
q.safeDefineElement(CartRemoveButton)
q.safeDefineElement(SearchForm)
q.safeDefineElement(PredictiveSearch)
q.safeDefineElement(HeaderMenu)
q.safeDefineElement(DetailsModal)
q.safeDefineElement(MenuDrawer)
q.safeDefineElement(HeaderDrawer)
q.safeDefineElement(ModalDialog)
q.safeDefineElement(ModalOpener)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(WelcomePopup)
q.safeDefineElement(WaitlistPopup)
q.safeDefineElement(ContactFormModal)
q.safeDefineElement(WaitlistForm)
q.safeDefineElement(LocalizationForm)
q.safeDefineElement(RecentlyViewedManager)
q.safeDefineElement(WishlistButton)

openCartIfRedirect()
initSwym()
